var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "161px",
    height: "81px",
    viewBox: "-0.5 -0.5 161 81",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/140.0.0.0 Safari/537.36 Edg/140.0.0.0\" version=\"28.2.4\" scale=\"1\" border=\"0\"> <diagram name=\"P\\xE1gina-1\" id=\"Ari_Hm6nP6rEavx47Fki\"> <mxGraphModel dx=\"1273\" dy=\"622\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"xvDfeGq1Sza9m1BnvC7F-2\" value=\"\" style=\"ellipse;whiteSpace=wrap;html=1;aspect=fixed;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"360\" y=\"120\" width=\"80\" height=\"80\" as=\"geometry\" /> </mxCell> <mxCell id=\"xvDfeGq1Sza9m1BnvC7F-3\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;rotation=-90;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"310\" y=\"150\" width=\"80\" height=\"20\" as=\"geometry\" /> </mxCell> <mxCell id=\"xvDfeGq1Sza9m1BnvC7F-4\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;rotation=-90;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"290\" y=\"150\" width=\"80\" height=\"20\" as=\"geometry\" /> </mxCell> <mxCell id=\"xvDfeGq1Sza9m1BnvC7F-5\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;rotation=-90;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"270\" y=\"150\" width=\"80\" height=\"20\" as=\"geometry\" /> </mxCell> <mxCell id=\"xvDfeGq1Sza9m1BnvC7F-6\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;rotation=-90;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"250\" y=\"150\" width=\"80\" height=\"20\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "xvDfeGq1Sza9m1BnvC7F-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 40,
    rx: 40,
    ry: 40,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "xvDfeGq1Sza9m1BnvC7F-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 80,
    height: 20,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-90,70,40)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "xvDfeGq1Sza9m1BnvC7F-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 80,
    height: 20,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-90,50,40)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "xvDfeGq1Sza9m1BnvC7F-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 30,
    width: 80,
    height: 20,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-90,30,40)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "xvDfeGq1Sza9m1BnvC7F-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 30,
    width: 80,
    height: 20,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-90,10,40)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerImage);
export default __webpack_public_path__ + "static/media/server_image.1aa3d1a9c5f8a46b5e68f437e2d05e9a.svg";
export { ForwardRef as ReactComponent };